import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class serasaHistoryKeys extends MainKeys {
    get place() {
        return Places.serasaHistory
    }

    get startDate() {
        const df = this._intent.getParameterAsString(ParamIds.serasaHistoryStartDate)
        return df ? new Date(df) : undefined
    }

    set startDate(value: Date | undefined) {
        this._intent.setParameter(ParamIds.serasaHistoryStartDate, value?.toISOString())
    }

    get endDate() {
        const df = this._intent.getParameterAsString(ParamIds.serasaHistoryEndDate)
        return df ? new Date(df) : undefined
    }

    set endDate(value: Date | undefined) {
        this._intent.setParameter(ParamIds.serasaHistoryEndDate, value?.toISOString())
    }

    get status() {
        return this._intent.getParameterAsString(ParamIds.serasaHistoryStatus)
    }

    set status(value: string | undefined) {
        this._intent.setParameter(ParamIds.serasaHistoryStatus, value)
    }

    get endpoint() {
        return this._intent.getParameterAsString(ParamIds.serasaHistoryEndpoint)
    }

    set endpoint(value: string | undefined) {
        this._intent.setParameter(ParamIds.serasaHistoryEndpoint, value)
    }
}

export default serasaHistoryKeys
